document.addEventListener('DOMContentLoaded', () => {

    const forms = document.querySelectorAll('.product-add-cart');
    forms.forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const formData = new FormData(form);
            const actionUrl = form.getAttribute('action') || window.location.href;

            fetch(actionUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            })
            .then(response => response.json())
            .then(data => {
                // Rileva la lingua corrente dall'URL
                const currentLang = window.location.pathname.startsWith('/en') ? 'en' : 'it';
                const translations = {
                    it: 'Prodotto aggiunto al carrello',
                    en: 'Product added to cart'
                };
                const message = translations[currentLang] || translations.it;
                
                // Mostra toast di conferma aggiunta al carrello
                const toast = document.createElement('div');
                toast.className = 'hs-removing:translate-x-5 hs-removing:opacity-0 transition duration-300 max-w-xs bg-secondary border border-gray-200 rounded-xl shadow-lg';
                toast.setAttribute('role', 'alert');
                toast.innerHTML = `
                    <div class="flex p-4">
                        <div class="flex-shrink-0">
                            <svg class="flex-shrink-0 size-4 text-teal-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                            </svg>
                        </div>
                        <div class="ms-3">
                            <p class="text-sm text-white">
                                ${message}
                            </p>
                        </div>
                    </div>
                `;

                // Aggiungi toast al body
                document.body.appendChild(toast);

                // Posiziona il toast in basso a destra
                toast.style.position = 'fixed';
                toast.style.bottom = '50px';
                toast.style.right = '20px';
                toast.style.zIndex = '9999';

                // Rimuovi automaticamente dopo 3 secondi
                setTimeout(() => {
                    toast.classList.add('hs-removing');
                    setTimeout(() => {
                        if (toast.parentNode) {
                            toast.parentNode.removeChild(toast);
                        }
                    }, 300);
                }, 3000);

                // Aggiorna contatore carrello nell'header se presente
                const cartCounters = document.querySelectorAll('.cart-counter');
                cartCounters.forEach(cartCounter => {
                    console.log(cartCounter.innerHTML);
                    if (cartCounter) {
                        const currentCount = parseInt(cartCounter.textContent) || 0;
                        const addedQuantity = parseInt(formData.get('quantity')) || 1;
                        cartCounter.textContent = currentCount + addedQuantity;
                    }
                });
            })
            .catch(error => {
                alert('Si è verificato un errore durante l\'aggiunta del prodotto al carrello.');
            });
        });
    });

    function updateCartQuantities() {
        const updateButton = document.getElementById('cart-update-cart-button');
        
        if (!updateButton) return;
        
        updateButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Recupera tutti gli input con data-detail
            const quantityInputs = document.querySelectorAll('input[type="number"][data-detail]');
            
            if (quantityInputs.length === 0) {
                alert('Nessun prodotto trovato nel carrello');
                return;
            }
            
            // Costruisci i dati da inviare come JSON
            const quantities = {};
            
            quantityInputs.forEach(input => {
                const detailId = input.getAttribute('data-detail');
                const quantity = parseInt(input.value) || 1;
                quantities[detailId] = quantity;
            });
            
            // URL dall'attributo data-url del pulsante
            const actionUrl = updateButton.getAttribute('data-url');
            
            if (!actionUrl) {
                alert('URL di aggiornamento non trovato');
                return;
            }
            
            // Disabilita il pulsante durante la richiesta
            updateButton.disabled = true;
            updateButton.textContent = 'Aggiornamento...';
            
            // Invia la richiesta AJAX con payload JSON
            fetch(actionUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    quantities: quantities
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Errore durante l\'aggiornamento del carrello');
                }
                return response.json();
            })
            .then(data => {
                if (data.status === 'success') {
                    // Ricarica la pagina o aggiorna la UI
                    location.reload();
                } else {
                    alert(data.message || 'Errore durante l\'aggiornamento del carrello');
                }
            })
            .catch(error => {
                console.error('Errore:', error);
                alert('Si è verificato un errore durante l\'aggiornamento del carrello');
            })
            .finally(() => {
                // Riabilita il pulsante
                updateButton.disabled = false;
                updateButton.textContent = 'Aggiorna carrello';
            });
        });
    }
    updateCartQuantities();

});

// **** OLD ****
function updateCartProducts() {
    const updateButton = document.getElementById('update-cart-products');
    const form = document.getElementById('cart-products-form');

    if (updateButton && form) {
        updateButton.addEventListener('click', function(event) {
            event.preventDefault();

            // TODO: controllo se la quantità in input è maggiore della max_quantity del prodotto presente a carrello, viene visualizzato un errore e non viene effettuato l'aggiornamento del carrello

            let update_cart_spinner = document.getElementById('update-cart-spinner');
            if (updateButton && update_cart_spinner) {
                updateButton.disabled = true;
                update_cart_spinner.classList.remove('d-none');
            }

            const formData = new FormData(form);

            fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                if (data.status == 'success') {
                    // alert('Carrello aggiornato');
                    location.reload();
                } else {
                    alert('Errore nell\'aggiornamento del carrello');
                    if (updateButton && update_cart_spinner) {
                        updateButton.disabled = false;
                        update_cart_spinner.classList.add('d-none');
                    }
                    
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        });
    }
}

function productQuantity() {

    const qtyGroupInput = document.querySelectorAll('.qty-group-input');

    qtyGroupInput.forEach(element => {
        let qtyPlus = element.querySelector('.quantity-right-plus');
        let qtyMinus = element.querySelector('.quantity-left-minus');
        let quantityField = document.getElementById(qtyPlus.dataset.target);

        qtyPlus.addEventListener('click', function (e) {
            e.preventDefault();
            let quantity = parseInt(quantityField.value);

            if(quantityField.dataset.max && quantity >= parseInt(quantityField.dataset.max)) {
                return;
            }

            quantityField.value = quantity + 1;
        });
    
        qtyMinus.addEventListener('click', function (e) {
            e.preventDefault();
            let quantity = parseInt(quantityField.value);
    
            if (quantity > 1) {
                quantityField.value = quantity - 1;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    productQuantity();
    updateCartProducts();
});